import { authBaseQuery } from "@entities/user";
import { createApi } from "@reduxjs/toolkit/query/react";
import {
  ADMIN_CHANNELS,
  ADMIN_CHANNEL_PRICES,
  ADMIN_USER_GROUPS,
  ADMIN_COMPLAINTS,
  ADMIN_REVIEWS,
  ADV_ORDERS,
  ADV_PROJECTS,
  ADV_PROJECT_REPORTS,
  ADV_TARIFF_ORDERS,
  ADV_TARIFF_PROJECTS,
  BALANCE,
  BLOGGER_CHANNELS,
  BLOGGER_OFFERS,
  CART,
  CART_MANAGER,
  CART_PUB,
  CART_PUB_SHORT,
  CATALOG,
  CHAT,
  LEGALS,
  MANAGER_ORDERS,
  MANAGER_PROJECTS,
  RECOMMEND_CARDS,
  TRANSACTION_HISTORY,
  USER_DATA,
  VIEWS_ADVERTISER,
  VIEWS_BLOGGER_CHANNELS,
  VIEWS_BLOGGER_OFFERS,
  VIEWS_MANAGER,
  VIEWS_TRANSACTIONS,
  CREATE_PROJECT_NAME,
  CREATE_PROJECT_POSTS,
  CREATE_PROJECT_DATES,
  CREATE_PROJECT_AMOUNT,
  MY_ORGANIZATION,
  ADMIN_ACCOUNTING,
  POST_TEMPLATES,
  AGENCY_PROJECTS_CUSTOMER,
  AGENCY_PROJECTS_PUBLISHER,
  AGENCY_PROJECTS_MANAGER,
  USER_ME,
  CART_SHORT,
  POST_ORDER,
} from "@shared/api/tags";

export const authApi = createApi({
  baseQuery: authBaseQuery,
  reducerPath: "authApi",
  endpoints: () => ({}),
  tagTypes: [
    POST_ORDER,
    CART,
    CART_SHORT,
    CART_MANAGER,
    CATALOG,
    RECOMMEND_CARDS,
    BLOGGER_CHANNELS,
    USER_DATA,
    USER_ME,
    CART_PUB,
    CART_PUB_SHORT,
    BALANCE,
    BLOGGER_OFFERS,
    ADV_PROJECTS,
    ADV_PROJECT_REPORTS,
    ADV_ORDERS,
    ADV_TARIFF_PROJECTS,
    ADV_TARIFF_ORDERS,
    MANAGER_PROJECTS,
    MANAGER_ORDERS,
    LEGALS,
    CHAT,
    ADMIN_REVIEWS,
    ADMIN_COMPLAINTS,
    ADMIN_CHANNELS,
    ADMIN_CHANNEL_PRICES,
    ADMIN_USER_GROUPS,
    ADMIN_ACCOUNTING,
    VIEWS_BLOGGER_CHANNELS,
    VIEWS_BLOGGER_OFFERS,
    VIEWS_ADVERTISER,
    VIEWS_MANAGER,
    VIEWS_TRANSACTIONS,
    TRANSACTION_HISTORY,
    CREATE_PROJECT_NAME,
    CREATE_PROJECT_POSTS,
    CREATE_PROJECT_DATES,
    CREATE_PROJECT_AMOUNT,
    MY_ORGANIZATION,
    POST_TEMPLATES,
    AGENCY_PROJECTS_CUSTOMER,
    AGENCY_PROJECTS_PUBLISHER,
    AGENCY_PROJECTS_MANAGER,
  ],
});
